import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { setActiveTab } from "../../redux/actions";
import logo from "../../assets/images/logo.svg";
// import i18n from '../../i18n';
import { useTranslation } from "react-i18next";
//import usFlag from "../../assets/images/flags/us.jpg";
//import brazil from "../../assets/images/flags/brazil.jpg";
import avatar1 from "../../assets/images/users/avatar-1.jpg";

function LeftSidebarMenu(props) {
  const user = props.loggedUser.data;
  const gestor = user.roles && user.roles.some((role) => role.id === 3);
  const profileImage = user.image !== null ? user.image : avatar1;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  //const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpenMobile, setDropdownOpenMobile] = useState(false);
  // const [lng, setlng] = useState("Portuguese");

  /* intilize t variable for multi language implementation */
  const { t } = useTranslation();

  const toggle = () => setDropdownOpen(!dropdownOpen);
  //const toggle2 = () => setDropdownOpen2(!dropdownOpen2);
  const toggleMobile = () => setDropdownOpenMobile(!dropdownOpenMobile);

  const toggleTab = (tab) => {
    props.setActiveTab(tab);
  };

  const activeTab = props.activeTab;

  /* changes language according to clicked language menu item */
  // const changeLanguageAction = (lng) => {

  //     /* set the selected language to i18n */
  //     i18n.changeLanguage(lng);

  //     if (lng === "pt")
  //         setlng("Portuguese");
  //     else if (lng === "sp")
  //         setlng("Spanish");
  //     else if (lng === "gr")
  //         setlng("German");
  //     else if (lng === "rs")
  //         setlng("Russian");
  //     else if (lng === "it")
  //         setlng("Italian");
  //     else if (lng === "eng")
  //         setlng("English");
  // }

  useEffect(() => {
    props.setActiveTab("chat");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="side-menu flex-lg-column me-lg-1">
        <div className="flex-lg-column d-none d-lg-block">
          <Nav vertical className="side-menu-nav justify-content-center">
            <Dropdown
              nav
              direction="down"
              isOpen={dropdownOpen}
              className="btn-group dropup nav-item profile-user-dropdown d-inline-block"
              toggle={toggle}
            >
              <DropdownToggle nav>
                <img src={profileImage} alt="" className="profile-user rounded-circle" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    toggleTab("profile");
                  }}
                >
                  {t("Profile")} <i className="ri-profile-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    toggleTab("settings");
                  }}
                >
                  {t("Setting")} <i className="ri-settings-3-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="/logout">
                  {t("Logout")} <i className="ri-logout-circle-r-line float-end text-muted"></i>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </div>
        {/* Side menu user */}

        {/* Start side-menu nav */}
        <div className="flex-lg-column my-auto" id="side-menu-nav">
          <Nav pills className="side-menu-nav justify-content-center" role="tablist">
            <NavItem id="profile">
              <NavLink
                id="pills-user-tab"
                className={classnames({ active: activeTab === "profile" })}
                onClick={() => {
                  toggleTab("profile");
                }}
              >
                <i className="ri-profile-line"></i>
              </NavLink>
            </NavItem>
            <UncontrolledTooltip target="profile" placement="top">
              {t("Profile")}
            </UncontrolledTooltip>
            <NavItem id="Chats">
              <NavLink
                id="pills-chat-tab"
                className={classnames({ active: activeTab === "chat" })}
                onClick={() => {
                  toggleTab("chat");
                }}
              >
                <i className="ri-message-3-line" />
              </NavLink>
            </NavItem>
            <UncontrolledTooltip target="Chats" placement="top">
              {t("Chats")}
            </UncontrolledTooltip>
            <NavItem id="InternalChats">
              <NavLink
                id="pills-internal-chat-tab"
                className={classnames({ active: activeTab === "internal-chat" })}
                onClick={() => {
                  toggleTab("internal-chat");
                }}
              >
                <i className="ri-message-2-line" />
              </NavLink>
            </NavItem>
            <UncontrolledTooltip target="InternalChats" placement="top">
              {t("Internal Chats")}
            </UncontrolledTooltip>
            <NavItem id="Contacts">
              <NavLink
                id="pills-contacts-tab"
                className={classnames({ active: activeTab === "contacts" })}
                onClick={() => {
                  toggleTab("contacts");
                }}
              >
                <i className="ri-contacts-line"></i>
              </NavLink>
            </NavItem>
            <UncontrolledTooltip target="Contacts" placement="top">
              {t("Contacts")}
            </UncontrolledTooltip>

            <NavItem id="Settings">
              <NavLink
                id="pills-setting-tab"
                className={classnames({ active: activeTab === "settings" })}
                onClick={() => {
                  toggleTab("settings");
                }}
              >
                <i className="ri-settings-2-line"></i>
              </NavLink>
            </NavItem>
            <UncontrolledTooltip target="Settings" placement="top">
              {t("Settings")}
            </UncontrolledTooltip>

            {gestor && (
              <>
                <NavItem id="DashboardGestor">
                  <NavLink
                    id="pills-dashboard-gestor-tab"
                    className={classnames({ active: activeTab === "dashboard-gestor" })}
                    onClick={() => {
                      toggleTab("dashboard-gestor");
                    }}
                  >
                    <i className="ri-dashboard-line"></i>
                  </NavLink>
                </NavItem>
                <UncontrolledTooltip target="DashboardGestor" placement="top">
                  {t("DashboardGestor")}
                </UncontrolledTooltip>

                {/* <NavItem id="WhatsappMenus">
                            <NavLink id="pills-whatsapp-menus-tab" className={classnames({ active: activeTab === 'whatsapp-menus' })} onClick={() => { toggleTab('whatsapp-menus'); }}>
                                <i className="ri-dashboard-line"></i>
                            </NavLink>
                        </NavItem>
                        <UncontrolledTooltip target="WhatsappMenus" placement="top">
                            {t('WhatsappMenus')}
                        </UncontrolledTooltip> */}
              </>
            )}

            <Dropdown
              nav
              direction="up"
              isOpen={dropdownOpenMobile}
              toggle={toggleMobile}
              className="profile-user-dropdown d-inline-block d-lg-none"
            >
              <DropdownToggle nav>
                <img src={profileImage} alt="leftsidebarmenu_avatar" className="profile-user rounded-circle" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    toggleTab("profile");
                  }}
                >
                  {t("Profile")} <i className="ri-profile-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    toggleTab("settings");
                  }}
                >
                  {t("Setting")} <i className="ri-settings-3-line float-end text-muted"></i>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="/logout">
                  {t("Logout")} <i className="ri-logout-circle-r-line float-end text-muted"></i>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </div>
        {/* end side-menu nav */}

        {/*<div className="flex-lg-column d-none d-lg-block">
                    <Nav vertical className="side-menu-nav justify-content-center">
                        <Dropdown nav direction="up" isOpen={dropdownOpen2} className="btn-group dropup profile-user-dropdown" toggle={toggle2}>
                            <DropdownToggle nav>
                                <i className="ri-global-line"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem onClick={() => changeLanguageAction('pt')} active={lng === "Portuguese"}>
                                    <img src={brazil} alt="user" className="me-1" height="12" /> <span className="align-middle">{t('Portuguese')}</span>
                                </DropdownItem>
                                <DropdownItem onClick={() => changeLanguageAction('eng')} active={lng === "English"}>
                                    <img src={usFlag} alt="user" className="me-1" height="12" /> <span className="align-middle">{t('English')}</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                        <NavItem>
                            <NavLink id="light-dark" target="_blank" href="//chatvia-light.react.themesbrand.com/">
                                <i className="ri-sun-line theme-mode-icon"></i>
                            </NavLink>
                            <UncontrolledTooltip target="light-dark" placement="right">
                                {t('Dark / Light Mode')}
                            </UncontrolledTooltip>
                       <Dropdown nav direction="end" isOpen={dropdownOpen} className="btn-group dropup nav-item profile-user-dropdown d-inline-block" toggle={toggle}>
                            <DropdownToggle nav><img src={profileImage} alt="" className="profile-user rounded-circle"/></DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => { toggleTab('profile'); }}>{t('Profile')} <i className="ri-profile-line float-end text-muted"></i></DropdownItem>
                                <DropdownItem onClick={() => { toggleTab('settings'); }}>{t('Setting')} <i className="ri-settings-3-line float-end text-muted"></i></DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem href="/logout">{t('Logout')} <i className="ri-logout-circle-r-line float-end text-muted"></i></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Nav>
                </div>*/}
        {/* Side menu user */}

        {/* LOGO */}
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="logo" height="30" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="logo" height="30" />
            </span>
          </Link>
        </div>
        {/* end navbar-brand-box  */}
      </div>
    </React.Fragment>
  );
}

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default connect(mapStatetoProps, { setActiveTab })(LeftSidebarMenu);
